import { defaultConfig } from '@chakra-ui/react';

import { buttonRecipe } from './button';
import { headingRecipe } from './heading';
import { inputRecipe } from './input';
import { textRecipe } from './text';

const recipes = {
    ...defaultConfig.theme?.recipes,
    input: inputRecipe,
    heading: headingRecipe,
    button: buttonRecipe,
    text: textRecipe,
};

export { recipes };
